<template>
  <span>
    <slot name="modalTrigger">
      <a href="#" @click.prevent="$bvModal.show('create-op-button' + '-' + id + '-' + opId)"
        ><i class="pr-1 fa fa-lg fa-arrow-right ml-1"></i
      ></a>
    </slot>
    <b-modal
      :id="'create-op-button' + '-' + id + '-' + opId"
      :title="'Crear/Editar Orden de pedido ' + opId"
      size="lg"
      @ok="onSubmit"
      @show="onShow"
      :ok-disabled="$v.form.$invalid || loading"
    >
      <b-form>
        <b-row>
          <b-col class="border-right">
            <b-form-group label="Fecha de entrega" label-for="delivery_date">
              <b-form-datepicker
                id="delivery_date"
                v-model="$v.form.delivery_date.$model"
                :state="$v.form.delivery_date.$dirty ? !$v.form.delivery_date.$error : null"
              ></b-form-datepicker>
            </b-form-group>
            <b-form-group label="Estado" label-for="delivery_date">
              <b-form-select :options="['vigente', 'completado', 'cancelado']" v-model="form.status"></b-form-select>
            </b-form-group>
            <b-form-group label="Cajas" label-for="quantity">
              <b-form-input
                id="quantity"
                v-model="$v.form.quantity.$model"
                :state="$v.form.quantity.$dirty ? !$v.form.quantity.$error : null"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              label="Kilos"
              label-for="kilograms"
              :description="`No debe pasarse de la totalidad del plan. Le quedan (${remainingKilograms}Kg).`"
            >
              <b-form-input id="kilograms" disabled :value="kilograms"></b-form-input>
            </b-form-group>
            <!-- <b-form-group label="Requerimientos especiales">
              <filter-op-modal
                :ref="`filter-op-${id}`"
                :id="`filter-op-modal-${id}`"
                @ok="handleFilterOk"
              ></filter-op-modal>
            </b-form-group> -->
            <b-form-group label="Incluir pallets especiales">
              <include-pallets :id="`include-pallets-modal-${id}`" @ok="handleSelectedItemsOk"></include-pallets>
              {{ itemList }}
            </b-form-group>
          </b-col>
          <b-col>
            <!-- Formato(container), Calibre(calibre), Sobrepeso(sobrepeso), Etiqueta(etiqueta), Envío(shipment_type) -->
            <b-form-group label="Formato" label-for="container">
              <b-form-select
                id="container"
                v-model="$v.form.container.$model"
                :state="$v.form.container.$dirty ? !$v.form.container.$error : null"
                :options="containerOptions"
                :reduce="(option) => option.value"
              ></b-form-select>
            </b-form-group>
            <b-form-group label="Calibre" label-for="calibre">
              <b-form-select
                id="calibre"
                v-model="$v.form.caliber.$model"
                :state="$v.form.caliber.$dirty ? !$v.form.caliber.$error : null"
                :options="caliberOptions"
              ></b-form-select>
            </b-form-group>
            <b-form-group label="Sobrepeso" label-for="sobrepeso">
              <b-form-select
                id="sobrepeso"
                v-model="$v.form.overweight.$model"
                :state="$v.form.overweight.$dirty ? !$v.form.overweight.$error : null"
                :options="sobrepesoOptions"
              ></b-form-select>
            </b-form-group>
            <b-form-group label="Etiqueta" label-for="etiqueta">
              <b-form-select
                id="etiqueta"
                v-model="$v.form.label.$model"
                :state="$v.form.label.$dirty ? !$v.form.label.$error : null"
                :options="labelOptions"
              ></b-form-select>
            </b-form-group>
            <b-form-group label="Envío" label-for="shipment_type">
              <b-form-select
                id="shipment_type"
                v-model="$v.form.shipment_type.$model"
                :state="$v.form.shipment_type.$dirty ? !$v.form.shipment_type.$error : null"
                :options="shipmentTypeOptions"
              ></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>
  </span>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import FilterOpModal from "../procesos/produccion/ProductionPlan/FilterOpModal";
import IncludePallets from "./IncludePallets.vue";
export default {
  name: "CreatePurchaseOrder",
  components: {
    FilterOpModal,
    IncludePallets
  },
  props: {
    id: {
      type: Number,
      default: 0
    },
    opId: {
      type: Number,
      default: 0
    },
    planId: {
      type: Number
    },
    clientCustomerId: {
      type: Number
    },
    containerId: {
      type: Number
    },
    planData: {
      type: Object
    }
  },
  data() {
    return {
      loading: false,
      form: {
        id: null,
        client_customer: null,
        delivery_date: null,
        plan: null,
        container: null,
        status: null,
        config: {},
        quantity: 0,
        caliber: null,
        overweight: 0,
        label: null,
        shipment_type: null
      },
      selectedItems: [],
      clientCustomerOptions: [],
      plansOptions: [],
      containerOptions: [],
      maxKilograms: 0,
      container: null,
      caliberOptions: [],
      sobrepesoOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      labelOptions: [],
      shipmentTypeOptions: [
        { value: 1, text: "Marítimo" },
        { value: 2, text: "Aéreo" },
        { value: 3, text: "Terrestre" }
      ]
    };
  },
  validations() {
    return {
      form: {
        client_customer: {
          required
        },
        delivery_date: {
          required
        },
        plan: {
          required
        },
        container: {
          required
        },
        status: {
          required
        },
        quantity: {
          required,
          validateMaxKilograms: this.validateMaxKilograms
        },
        caliber: {
          required
        },
        overweight: {
          required
        },
        label: {
          required
        },
        shipment_type: {
          required
        }
      }
    };
  },
  computed: {
    kilograms() {
      if (this.container) {
        let num = this.form.quantity * parseFloat(this.container.value.net_weight);
        num = Math.round(num * 100) / 100;
        return num;
      } else {
        return 0;
      }
    },
    remainingKilograms() {
      return this.maxKilograms - this.kilograms;
    },
    itemList() {
      if (this.selectedItems.length > 0) {
        return this.selectedItems.map((item) => item.pallet_number).join(", ");
      } else {
        return "Nada selecionado";
      }
    }
  },
  methods: {
    resetForm() {
      this.form = {
        id: null,
        client_customer: null,
        delivery_date: null,
        plan: null,
        container: null,
        config: {},
        status: null,
        kilograms: null,
        quantity: 0,
        caliber: null,
        overweight: 0,
        label: null,
        shipment_type: null
      };
      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    handleSelectedItemsOk(payload) {
      if (payload["pallets"] && payload["pallets"].length > 0) {
        this.selectedItems = payload["pallets"];
        this.form.config["sidePallets"] = payload;
      }
    },
    handleFilterOk(data) {
      this.form.config["defects"] = data;
    },
    async fetchContainers() {
      const res = await this.$axios.get("/production/all_containers");
      this.containerOptions = res.data;
    },
    // Fetch the customfields
    async fetchSelects() {
      const res = await this.$axios.get("/production/purchaseorder/get_selects_for_purchas_order");
      this.caliberOptions = res.data.calibre;
      this.labelOptions = res.data.etiqueta;
    },
    onShow() {
      this.fetchContainers();
      this.fetchSelects();
      if (this.opId === 0) {
        this.form.client_customer = this.planData.client_customer;
        this.getContainer(this.planData.container).then((data) => {
          this.form.plan = this.planData.id;
          this.form.container = this.planData.container;
          this.form.status = this.planData.status;
          this.maxKilograms = this.planData.kilograms;
          this.container = data;
          this.loading = false;
        });
      } else {
        this.getOp().then((data) => {
          this.form.client_customer = data.plan.client_customer;
          this.form.id = data.id;
          this.form.delivery_date = data.delivery_date;
          this.form.quantity = data.quantity;
          this.form.caliber = data.caliber;
          this.form.overweight = data.overweight;
          this.form.label = data.label;
          this.form.shipment_type = data.shipment_type;
          this.form.kilograms = data.kilograms;
          this.form.config = data.config;
          // this.$refs[`filter-op-${this.id}`].selectedDefects = data.config.defects || [];
          this.form.plan = data.plan.id;
          this.form.container = data.plan.container;
          this.form.status = data.plan.status;
          this.getPlan(data.plan.id).then((plan) => {
            this.maxKilograms = plan.kilograms;
            this.getContainer(plan.container).then((container) => {
              this.container = container;
              this.loading = false;
            });
          });
        });
      }
    },
    validateMaxKilograms() {
      if (this.remainingKilograms < 0) {
        console.log("ACAACK!!! 🐔", "te pasaste");
        return false;
      } else {
        return true;
      }
    },
    async getOp() {
      try {
        const response = await this.$axios.get(
          `/api/v1/purchase_order/${this.opId}/?fields=id,delivery_date,quantity,kilograms,container,status,plan,config,label,container,shipment_type,caliber,overweight&expand=plan`
        );
        return response.data;
      } catch (error) {
        this.$bvToast.toast("Error al obtener la orden de pedido.", {
          title: "Error",
          variant: "danger",
          solid: true
        });
        console.log(error);
      }
    },
    async getPlan(planId) {
      try {
        const response = await this.$axios.get(`/api/comex/plan/${planId}/`);
        return response.data;
      } catch (error) {
        this.$bvToast.toast("Error al obtener plan.", {
          title: "Error",
          variant: "danger",
          solid: true
        });
        console.log(error);
      }
    },
    async onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      let method = "post";
      let url = "/api/v1/purchase_order/";
      if (this.opId !== 0) {
        method = "put";
        url = `/api/v1/purchase_order/${this.opId}/`;
      }

      this.loading = true;
      const data = {
        client_customer: this.form.client_customer,
        delivery_date: this.form.delivery_date,
        plan: this.form.plan,
        container: this.form.container,
        status: this.form.status,
        quantity: this.form.quantity,
        config: this.form.config,
        kilograms: this.kilograms,
        caliber: this.form.caliber,
        overweight: this.form.overweight,
        label: this.form.label,
        shipment_type: this.form.shipment_type
      };
      try {
        await this.$axios({ method, url, data });
        this.$bvModal.hide("create-op-button" + this.id);
        this.$swal("¡Éxito!", "Orden de pedido creada", "success");
        this.$emit("refresh");
      } catch (error) {
        this.$bvToast.toast("Error al crear la orden de pedido", {
          title: "Error",
          variant: "danger",
          solid: true
        });
      }
      this.loading = false;
      this.resetForm();
    },
    async getContainer(container_id) {
      this.loading = true;
      try {
        const response = await this.$axios.get(`/api/v1/container/${container_id}/`);
        return response.data;
      } catch (error) {
        console.log(error);
        return null;
      }
    }
  }
};
</script>

<style></style>
